class FieldSizing {
    // Polyfill for field-sizing
    constructor(el) {
        this.el = el;

        this.fieldSizing = this.el.dataset.fieldSizing;

        this._setWidth();

        if (this.fieldSizing === "content") {
            el.addEventListener("change", () => {
                this._setWidth();
            });
        }
    }

    _setWidth(length = this.el.value.length) {
        this.length = this.el.value.length;

        if (this.length < 1) {
            this.length = this.el.placeholder.length;
        }

        this.el.style.setProperty("--field-sizing--length", this.length);
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const fieldSizingEls = document.querySelectorAll(`[data-field-sizing]`);

    if (CSS.supports("field-sizing", "content")) {
        return;
    }

    fieldSizingEls.forEach((element) => {
        new FieldSizing(element);
    });
});
